import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {InvoiceOrdersPage as InvoiceOrders} from './pages/InvoiceOrdersPage';

export default function InvoiceOrdersPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/invoice-orders" component={InvoiceOrders} />
            </Switch>
        </Suspense>
    );
}
